<template>
  <BreadCrumb PageTitle="Background" />
  <BackgroundColors />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import BackgroundColors from "../../template-components/Utilities/Background/BackgroundColors.vue";

export default defineComponent({
  name: "BackgroundPage",
  components: {
    BreadCrumb,
    BackgroundColors,
  },
});
</script>